// import React, { useState } from "react";
// import { WebApiURL } from "../Constants/Constants";
// import OtpVerifyForm from "./OtpVerifyForm";

// function LoginForm({ setActiveForm }) {
//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     rememberMe: false,
//   });

//   const [statusMessage, setStatusMessage] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showOtp, setShowOtp] = useState(false);

//   const handleInputChange = (e) => {
//     const { id, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [id]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatusMessage("");
//     setIsSubmitting(true);

//     try {
//       const response = await fetch(`${WebApiURL}Verification/login`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       const text = await response.text();
//       let data;
//       try {
//         data = JSON.parse(text);
//       } catch {
//         data = text;
//       }

//       if (response.ok && data.user) {
//         setStatusMessage("OTP sent to your email. Please verify.");

//         // ✅ Save email and user info in localStorage
//         localStorage.setItem("email", formData.email);
//         localStorage.setItem("source", "login");

//         // Save full user object
//         localStorage.setItem("user", JSON.stringify(data.user));

//         // Save role separately for easier access
//         localStorage.setItem("role", data.user.role || "NormalUser");

//         // Show OTP verification screen
//         setShowOtp(true);
//       } else {
//         setStatusMessage((data && data.message) || data || "Login failed.");
//       }
//     } catch (error) {
//       console.error(error);
//       setStatusMessage("Server error or network issue.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (showOtp) {
//     return <OtpVerifyForm setActiveForm={setActiveForm} source="login" />;
//   }

//   return (
//     <div className="max-564 w-100 rounded-1 border p-4">
//       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
//         Please Log in
//       </div>

//       {statusMessage && (
//         <div
//           className={`alert ${
//             statusMessage.includes("OTP sent") ? "alert-success" : "alert-danger"
//           }`}
//         >
//           {statusMessage}
//         </div>
//       )}

//       <form className="login-form" onSubmit={handleSubmit}>
//         <div className="form-group mb-3">
//           <label htmlFor="email" className="form-label font-17 font-400 text-primary-green mb-1">
//             Email
//           </label>
//           <input
//             type="email"
//             className="form-control height-40 rounded-1 border-color-7D9199"
//             id="email"
//             placeholder="Enter your email"
//             value={formData.email}
//             onChange={handleInputChange}
//             required
//           />
//         </div>

//         <div className="form-group mb-3">
//           <label htmlFor="password" className="form-label font-17 font-400 text-primary-green mb-1">
//             Password
//           </label>
//           <input
//             type="password"
//             className="form-control height-40 rounded-1 border-color-7D9199"
//             id="password"
//             placeholder="Enter your password"
//             value={formData.password}
//             onChange={handleInputChange}
//             required
//           />
//         </div>

//         <div className="form-group mb-4">
//           <div className="form-check">
//             <input
//               className="form-check-input"
//               type="checkbox"
//               id="rememberMe"
//               checked={formData.rememberMe}
//               onChange={handleInputChange}
//             />
//             <label className="form-check-label font-17 font-400 text-primary-green" htmlFor="rememberMe">
//               Remember Me?
//             </label>
//           </div>
//         </div>

//         <div className="form-group mb-2">
//           <button
//             type="submit"
//             className="btn btn-primary-green w-100 height-50 rounded-1"
//             disabled={isSubmitting}
//           >
//             {isSubmitting ? "Logging in..." : "Log In"}
//           </button>
//         </div>

//         <div className="form-group d-flex justify-content-between">
//           <button
//             type="button"
//             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//             onClick={() => setActiveForm("forgot")}
//           >
//             Forgot Your Password?
//           </button>
//           <button
//             type="button"
//             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//             onClick={() => setActiveForm("register")}
//           >
//             Create SAMSA Profile
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default LoginForm;
import React, { useState } from "react";
import { WebApiURL } from "../Constants/Constants";
import OtpVerifyForm from "./OtpVerifyForm";

function LoginForm({ setActiveForm }) {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showOtp, setShowOtp] = useState(false);

  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    setIsSubmitting(true);

    try {
      const response = await fetch(`${WebApiURL}Verification/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
        

      } catch {
        data = text;
      }

      if (response.ok && data.user) {
    setStatusMessage("OTP sent to your email. Please verify.");

    // Save email and source
    localStorage.setItem("email", formData.email);
    localStorage.setItem("source", "login");

    // Save full user object (includes role)
    localStorage.setItem("user", JSON.stringify(data.user));

    // Optional: save role separately for quick access
    localStorage.setItem("role", data.user.role || "NormalUser");

    // Show OTP verification screen
    setShowOtp(true);
      } else {
        setStatusMessage((data && data.message) || data || "Login failed.");
      }
    } catch (error) {
      console.error(error);
      setStatusMessage("Server error or network issue.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (showOtp) {
    return <OtpVerifyForm setActiveForm={setActiveForm} source="login" />;
  }

  return (
    <div className="max-564 w-100 rounded-1 border p-4">
      <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
        Please Log in
      </div>

      {statusMessage && (
        <div
          className={`alert ${
            statusMessage.includes("OTP sent") ? "alert-success" : "alert-danger"
          }`}
        >
          {statusMessage}
        </div>
      )}

      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label htmlFor="email" className="form-label font-17 font-400 text-primary-green mb-1">
            Email
          </label>
          <input
            type="email"
            className="form-control height-40 rounded-1 border-color-7D9199"
            id="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group mb-3">
          <label htmlFor="password" className="form-label font-17 font-400 text-primary-green mb-1">
            Password
          </label>
          <input
            type="password"
            className="form-control height-40 rounded-1 border-color-7D9199"
            id="password"
            placeholder="Enter your password"
            value={formData.password}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group mb-4">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="rememberMe"
              checked={formData.rememberMe}
              onChange={handleInputChange}
            />
            <label className="form-check-label font-17 font-400 text-primary-green" htmlFor="rememberMe">
              Remember Me?
            </label>
          </div>
        </div>

        <div className="form-group mb-2">
          <button
            type="submit"
            className="btn btn-primary-green w-100 height-50 rounded-1"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Logging in..." : "Log In"}
          </button>
        </div>

        <div className="form-group d-flex justify-content-between">
          <button
            type="button"
            className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
            onClick={() => setActiveForm("forgot")}
          >
            Forgot Your Password?
          </button>
          <button
            type="button"
            className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
            onClick={() => setActiveForm("register")}
          >
            Create SAMSA Profile
          </button>
        </div>
      </form>
    </div>
  );
}

export default LoginForm;
